module.exports = __webpack_public_path__ + "img/program_img1.7f902451.png";